import { render } from "./PackageOwnerForm.vue?vue&type=template&id=4037b966"
import script from "./PackageOwnerForm.vue?vue&type=script&lang=js"
export * from "./PackageOwnerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__